import levels from './levelsSlice'
import speed from './speedSlice'
import music from './musicSlice'
import pause from './pauseSlice'
import games from './gamesSlice'
import game from './gameSlice'
import tetris from './tetrisSlice'
import lock from './lockSlice'
import snake from './snakeSlice'
import shooting from './shootingSlice'
import breakout from './breakoutSlice'
import racing from './racingSlice'
import tank from './tankSlice'
import leaderboard from './leaderboardSlice'

export default {
  levels,
  speed,
  music,
  pause,
  games,
  game,
  tetris,
  lock,
  snake,
  shooting,
  breakout,
  racing,
  tank,
  leaderboard,
}
